import questions from "../data/questions.json";
import norms from "../data/norms.json";
import { CONSTANTS } from "./constants";

export function calculateScore(testId, responses) {
  const test = questions[testId];
  const { mean, sd } = norms[testId];
  let total = 0;

  Object.entries(responses).forEach(([qIndex, value]) => {
    const q = test.questions[qIndex];
    let score = 0

    if (testId === "cat") {
      if (q.add === value) {
        score = 1;
      }
    } else {
      score = value;
    }
    total += score;
  });

  const z = (total - mean) / sd;
  
  let interpretation = "";
  if (z < 2.0) interpretation = CONSTANTS.CLINICALLYINSIGNIFICANT
  else interpretation = CONSTANTS.CLINICALLYSIGNIFICANT;

  return { total, z: z.toFixed(2), interpretation, mean, sd };
}